import styled from 'styled-components';
import {getFontSize, getFontWeight, getPrimitive, getSpacing} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {alignStart, dFlex, dFlexColumnCenter, dFlexCenter, justifyBetween} from '../../../../globalVariables/GlobalFlex';

export const container = styled.div`
    position: relative;
    width: 100%;
    padding: ${getSpacing('spaceXl')} 0;
    margin-bottom: ${getSpacing('spaceXl')};
    ${mobileMedia} {
        padding: ${getSpacing('spaceLg')} 0;
        margin-bottom: ${getSpacing('spaceLg')};
    }
    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-color: ${getPrimitive('grays.gray300')};
        position: absolute;
        top: 32px;
    }
`;

export const pointsContainer = styled.div`
    position: relative;
    ${dFlex}
    ${alignStart}
    ${justifyBetween}
    width: 100%;
    ${mobileMedia} {
        flex-wrap: wrap;
        gap: ${getSpacing('spaceMd')};
        padding-left: 0;
        padding-top: ${getSpacing('spaceSm')};
    }
`;

export const pointWrapper = styled.div`
    ${dFlexColumnCenter};
    width: 65px;
    gap: ${getSpacing('spaceSm')};
`;

export const point = styled.div<{isActive: boolean}>`
    width: 17px;
    height: 17px;
    padding: ${getSpacing('spaceXs')};
    border-radius: 8.5px;
    background-color: ${p => p.isActive 
    ? getPrimitive('turquoise.turquoise400') 
    : getPrimitive('grays.gray200')};
    position: relative;
    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 4.5px;
        background-color: ${p => p.isActive 
        ? getPrimitive('turquoise.turquoise100') 
        : getPrimitive('grays.gray400')};
    }

    ${mobileMedia} {
        width: 14px;
        height: 14px;
        padding: 3px;
    }
`;

export const label = styled.div<{isActive: boolean}>`
    font-size: ${getFontSize('caption')};
    font-weight: ${p => p.isActive ? getFontWeight('medium') : getFontWeight('normal')};
    color: ${getPrimitive('solids.black')};
    line-height: 12px;
    letter-spacing: 0.12px;
    text-align: center;
    white-space: pre-line;
`;

export const durationBadge = styled.div`
    position: relative;
    width: 52px;
    height: 14px;
    background-color: ${getPrimitive('turquoise.turquoise100')};
    border: 1px solid ${getPrimitive('turquoise.turquoise400')};
    border-radius: 48px;
    ${dFlexCenter};
    font-size: ${getFontSize('caption')};
    color: ${getPrimitive('solids.black')};
    line-height: 10px;
`;

